import { Component, OnInit } from '@angular/core';

import { getObjectivePropertySelectors } from 'src/app/modules/objective/store/objective.selectors';
import { IObjectivesFormState } from 'src/app/modules/objective/store/objective.state';

import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { formatDate } from 'src/app/utils/format-date';
import { formatCurrency } from 'src/app/utils/format-currency';

@Component({
  selector: 'app-pdf-property',
  templateUrl: './pdf-property.component.html',
  styleUrls: ['./pdf-property.component.scss'],
})
export class PdfPropertyComponent implements OnInit {
  dataStoreProperty$: Observable<any>;
  dataStoreProperty: IObjectivesFormState;
  intendDate: any;
  minInvestimentFormated: string;
  maxInvestimentFormated: string;

  constructor(private store: Store) {}

  getState() {
    this.dataStoreProperty$ = this.store.select(getObjectivePropertySelectors);
    this.dataStoreProperty$.subscribe((value) => {
      this.dataStoreProperty = {
        ...(this.dataStoreProperty = value),
      };
    });

    this.intendDate = this.dataStoreProperty.date;
    if (this.intendDate) {
      this.intendDate = formatDate(this.intendDate);
    } else {
      this.intendDate = 'data não especificada!';
    }

    this.minInvestimentFormated = formatCurrency(
      this.dataStoreProperty.minimumInvestment
    );
    this.maxInvestimentFormated = formatCurrency(
      this.dataStoreProperty.maximumInvestment
    );
  }

  ngOnInit(): void {
    this.getState();
  }


}
